import React, { useState } from "react";
import { strings } from "../../Translations/strings";
import Header from "../Components/header";
import "../Auth.scss";
import ResetPasswordForm from "./ResetPasswordForm";

const ResetPassword = () => {
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSuccessChange = (success) => {
    setIsSuccess(success);
  };

  return (
    <div className="d-flex justify-content-center align-items-center login-container">
      <Header />
      <div className="contet-wrapper">
        <div className="form-container">
          {!isSuccess && (
            <p className="header-title">{strings.reset_password_title}</p>
          )}
          {!isSuccess && (
            <p className="forgot-password-description">{strings.forgot_password_description}</p>
          )}
          <ResetPasswordForm onSuccessChange={handleSuccessChange} />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
